import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import '@densityco/ui';
import './global-styles.scss';

import { ON_PREM } from './utils/environment';
import { Router } from 'react-router-dom';
import hashHistory from './history';

import App from "./components/app/App";
import {Hosts} from './utils/host';
import {onStartup} from './startup';

const sentryHost = Hosts.SentryHost;
if (sentryHost !== null) {
  Sentry.init({
    dsn: 'https://a87ea8efdcf140a48ab878b0e6b3a5b3@sentry.io/1524349',
    environment: sentryHost,
  });
}

if (ON_PREM) {
  import('./error-collector');
}

onStartup();

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <Router history={hashHistory}>
    <App />
  </Router>
);
